import { Component, ElementRef, AfterViewInit, ViewChild, OnDestroy, ViewContainerRef } from '@angular/core';
import { ParticleEffects, ParticleEffectsOverlayService } from './particle-effects-overlay.service';
import { Observable, Subscription } from 'rxjs';
import { LoggingService, LogSeverity } from '@core/services/logging.service';

@Component({
  selector: 'app-particle-effects-overlay',
  templateUrl: './particle-effects-overlay.component.html',
  styleUrls: ['./particle-effects-overlay.component.scss'],
  standalone: false,
})
export class ParticleEffectsOverlayComponent implements AfterViewInit, OnDestroy {
  @ViewChild('overlayParent') parentElem!: ElementRef;

  private overlayTrigger: Observable<ParticleEffects | undefined>;
  private unsubOverlayTrigger: Subscription | undefined;
  private currentParticleEffect: ParticleEffects | undefined;
  public currentParticleComponent: ParticleEffects | undefined;
  public particleEffectsTypes = ParticleEffects; // Used to expose the enum to the template.

  constructor(
    private particleEffectsOverlayService: ParticleEffectsOverlayService,
    private logger: LoggingService,
    private viewRef: ViewContainerRef,
  ) {
    this.overlayTrigger = this.particleEffectsOverlayService.getTrigger();
  }

  ngAfterViewInit() {
    this.unsubOverlayTrigger = this.overlayTrigger.subscribe((particleEffect: ParticleEffects | undefined) => {
      if (particleEffect !== undefined) {
        // If a particle effect was provide it- switch to it.
        this.startParticleEffect(particleEffect);
      } else {
        // No overlay provided, stop any existing overlay
        this.stopParticleEffect();
      }
    });
    // TODO: This line is hardcoded for testing and should be removed in favor of a Flipt integration
    this.particleEffectsOverlayService.loadParticleEffect(ParticleEffects.SNOW);
  }

  ngOnDestroy(): void {
    if (this.unsubOverlayTrigger) {
      this.unsubOverlayTrigger.unsubscribe();
    }
  }

  /**
   * Sets the current particle effect to the incoming effect- replacing
   * any exising effects that may be in use. Also unhides the parent element
   * to allow the effects to be visible.
   * @param particleEffect - New particle effect from ParticleEffects enum
   */
  private startParticleEffect(particleEffect: ParticleEffects) {
    this.currentParticleEffect = particleEffect;

    const parentDiv = this.parentElem.nativeElement as HTMLDivElement;
    parentDiv.style.display = 'block';
    parentDiv.style.background = 'transparent';

    this.currentParticleComponent = particleEffect;

    this.logger.writeLog(
      `[ParticleEffectsComponent:startParticleEffect] Effect overlay started for ${particleEffect}`,
      {
        effect: this.currentParticleEffect,
        severity: LogSeverity.DEBUG,
      },
    );
  }

  /**
   * If we have a particle effect applied, we will clear the
   * existing value and then hide the parent element from the page.
   */
  private stopParticleEffect() {
    if (this.currentParticleEffect) {
      const parentDiv = this.parentElem.nativeElement as HTMLDivElement;
      parentDiv.style.display = 'none';
      parentDiv.innerHTML = '';
      this.logger.writeLog(`[ParticleEffectsComponent:stopParticleEffect] Effect overlay stopped`, {
        severity: LogSeverity.DEBUG,
      });

      this.currentParticleEffect = undefined;
    }
  }
}
